'use strict';
import * as $j_app$002edata$002e$002dUser$002dKind$0024$002dMember from "./app.data.-User-Kind$-Member.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserKind$Member$() {
}
export { $c_Lapp_data_UserKind$Member$ as $c_Lapp_data_UserKind$Member$ };
$p = $c_Lapp_data_UserKind$Member$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserKind$Member$;
/** @constructor */
function $h_Lapp_data_UserKind$Member$() {
}
export { $h_Lapp_data_UserKind$Member$ as $h_Lapp_data_UserKind$Member$ };
$h_Lapp_data_UserKind$Member$.prototype = $p;
$p.n = (function() {
  return "Member";
});
$p.bL3 = (function(x$0) {
  return new $j_app$002edata$002e$002dUser$002dKind$0024$002dMember.$c_Lapp_data_UserKind$Member(x$0.e(0));
});
$p.U = (function(p) {
  return this.bL3(p);
});
var $d_Lapp_data_UserKind$Member$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserKind$Member$, "app.data.UserKind$Member$", ({
  Fr: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_UserKind$Member$ as $d_Lapp_data_UserKind$Member$ };
var $n_Lapp_data_UserKind$Member$;
function $m_Lapp_data_UserKind$Member$() {
  if ((!$n_Lapp_data_UserKind$Member$)) {
    $n_Lapp_data_UserKind$Member$ = new $c_Lapp_data_UserKind$Member$();
  }
  return $n_Lapp_data_UserKind$Member$;
}
export { $m_Lapp_data_UserKind$Member$ as $m_Lapp_data_UserKind$Member$ };
//# sourceMappingURL=app.data.-User-Kind$-Member$.js.map
